import styles from 'css/src/components/common/ui/IconCircle.module.scss';

import React from 'react';
import classNames from 'classnames';

type Props = {
    materialIconName?: string;
    onClick?: VoidFunction;
    size?: 'small' | 'large';
    color?: 'color-primary' | 'text-white' | 'color-black' | 'color-grey-600';
    backgroundColor?: 'primary' | 'white' | 'accent' | 'cherry';
    className?: string;
};

const IconCircle = React.memo(function IconCircle({
    materialIconName,
    onClick,
    size,
    color,
    backgroundColor,
    className,
}: Props) {
    return (
        <div
            className={classNames(
                styles['icon-circle'],
                'icon-overlay',
                className,
                size && styles[size],
                backgroundColor && styles[backgroundColor],
                { [styles['clickable']]: onClick },
            )}
            onClick={onClick}
        >
            <i translate="no" className={classNames('material-symbols-outlined icon-l5', color)}>
                {materialIconName}
            </i>
        </div>
    );
});

export default IconCircle;
